(function () {
  document.querySelectorAll('a[href="/pages/about"]').forEach(function (link) {
    link.href = '/pages/about-bbsc';
  });
  document.querySelectorAll('a[href="/pages/bbsc-membership-signup"]').forEach(function (link) {
    link.href = '/pages/membership?view=bbsc-membership-signup';
  });
  document.querySelectorAll('a[href="/pages/bbsc-publications?view=patch-partners"]').forEach(function (link) {
    link.href = '/pages/patch-partners';
  });

  function ensurePatchPartnersBilly() {
    if (window.location.pathname !== '/pages/patch-partners') return;
    if (!document.querySelector('.bbsc-patch-partners')) return;

    document.querySelectorAll('a[href^="/pages/bbsc-publications?view=patch-partners-"]').forEach(function (link) {
      link.href = link.getAttribute('href').replace('/pages/bbsc-publications?view=', '/pages/');
    });

    if (!document.getElementById('bbsc-patch-partners-billy-fallback-style')) {
      var style = document.createElement('style');
      style.id = 'bbsc-patch-partners-billy-fallback-style';
      style.textContent = [
        '.pp-network-status{display:grid;grid-template-columns:minmax(0,.95fr) minmax(0,1.45fr);gap:1rem;align-items:stretch;margin-top:1rem}',
        '.pp-status-panel,.pp-roster-card{position:relative;overflow:hidden;border:1px solid rgba(255,216,108,.36);border-radius:8px;background:radial-gradient(circle at 0 0,rgba(157,255,53,.12),transparent 13rem),linear-gradient(180deg,rgba(7,28,15,.9),rgba(1,5,3,.95));box-shadow:inset 0 0 0 1px rgba(157,255,53,.05),0 16px 38px rgba(0,0,0,.26)}',
        '.pp-status-panel{display:grid;align-content:center;min-height:100%;padding:clamp(1rem,1.8vw,1.35rem)}',
        '.pp-status-panel strong{color:var(--pp-green-bright);font-family:"Playfair Display",Georgia,serif!important;font-size:clamp(2.4rem,4.3vw,4rem);font-weight:1000;line-height:.9;text-shadow:0 2px 2px #000,0 0 14px rgba(157,255,53,.2)}',
        '.pp-status-panel h3{margin:.55rem 0 .4rem;color:var(--pp-gold-bright);font-family:"Playfair Display",Georgia,serif!important;font-size:clamp(1.05rem,1.45vw,1.34rem);font-weight:1000;line-height:1.08;text-transform:uppercase}',
        '.pp-status-panel p{margin:0;color:var(--pp-muted);font-size:.9rem;font-weight:650;line-height:1.52}',
        '.pp-active-chips{display:flex;flex-wrap:wrap;gap:.45rem;margin-top:.85rem}',
        '.pp-active-chip{display:inline-flex;align-items:center;border:1px solid rgba(157,255,53,.58);border-radius:999px;background:rgba(157,255,53,.1);color:#e9ffd2;font-size:.68rem;font-weight:950;line-height:1;padding:.45rem .55rem;text-transform:uppercase}',
        '.pp-roster-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.75rem}',
        '.pp-roster-card{display:grid;gap:.45rem;min-height:155px;align-content:end;padding:.9rem;text-decoration:none}',
        '.pp-roster-card>b{width:max-content;max-width:100%;border:1px solid rgba(157,255,53,.58);border-radius:999px;background:rgba(2,24,11,.8);color:var(--pp-green-bright);font-size:.62rem;font-weight:950;line-height:1;padding:.35rem .48rem;text-transform:uppercase}',
        '.pp-roster-card>strong{color:var(--pp-gold-bright);font-family:"Playfair Display",Georgia,serif!important;font-size:1.05rem;font-weight:1000;line-height:1;text-transform:uppercase;text-shadow:0 2px 2px #000}',
        '.pp-roster-card span,.pp-roster-card p{margin:0;color:#f1e3c3;font-size:.78rem;font-weight:650;line-height:1.35;text-shadow:0 1px 2px rgba(0,0,0,.88)}',
        '@media(max-width:980px){.pp-network-status{grid-template-columns:1fr}.pp-roster-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}',
        '@media(max-width:640px){.pp-roster-grid{grid-template-columns:1fr}}'
      ].join('');
      document.head.appendChild(style);
    }

    var tickerGroups = document.querySelectorAll('.pp-hero__ticker-group');
    tickerGroups.forEach(function (group) {
      if (group.textContent.indexOf('Big Bud Billy') !== -1) return;
      group.insertAdjacentHTML('beforeend', [
        '<div class="pp-hero__ticker-item">',
        '<span class="pp-hero__ticker-badge" aria-hidden="true"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="17"/><path d="M24 12c5 6 6 12 0 20-6-8-5-14 0-20Z"/><path d="M24 32v6"/></svg></span>',
        '<span class="pp-hero__ticker-copy"><a class="pp-hero__ticker-name" href="/pages/big-bud-billy">Big Bud Billy</a><small class="pp-hero__ticker-category">Creators And Media</small><span class="pp-hero__ticker-description">Billy Taylor&apos;s Cannabis Comics world, bringing creator-owned comic storytelling to BBSC culture.</span></span>',
        '</div>'
      ].join(''));
    });

    var partnerPaths = document.getElementById('partner-paths');
    if (partnerPaths && !partnerPaths.querySelector('.pp-network-status')) {
      var intro = partnerPaths.querySelector('.pp-category-intro');
      var roster = document.createElement('div');
      roster.className = 'pp-network-status';
      roster.setAttribute('aria-label', 'Current approved BBSC Patch Partners');
      roster.innerHTML = [
        '<article class="pp-status-panel"><strong>4</strong><h3>Current Approved Partners</h3><p>The active categories are marked below, and the approved partners are listed here so visitors do not have to hunt for them.</p><div class="pp-active-chips" aria-label="Categories with approved partners"><span class="pp-active-chip">Education And Technology</span><span class="pp-active-chip">Education And Wellness</span><span class="pp-active-chip">Creators And Media</span></div></article>',
        '<div class="pp-roster-grid">',
        '<a class="pp-roster-card" href="/pages/mcpedia-patch-partner"><b>Approved Partner</b><strong>mcPEDIA</strong><span>Education And Technology</span><p>Knowledge, tools, and interactive learning resources for the BBSC ecosystem.</p></a>',
        '<a class="pp-roster-card" href="/pages/mariceuticals-collaboration"><b>Approved Partner</b><strong>Mariceuticals</strong><span>Education And Wellness</span><p>Education, wellness collaboration, and member-facing resource pathways.</p></a>',
        '<a class="pp-roster-card" href="/pages/gcew-guided-cannabis-elevated-wellness"><b>Approved Partner</b><strong>GCEW</strong><span>Education And Wellness</span><p>Guided Cannabis, Elevated Wellness and responsible learning support.</p></a>',
        '<a class="pp-roster-card" href="/pages/big-bud-billy"><b>Approved Partner</b><strong>Big Bud Billy</strong><span>Billy Taylor · Creators And Media</span><p>Billy Taylor&apos;s creator-owned Cannabis Comics storytelling inside the BBSC culture lane.</p></a>',
        '</div>'
      ].join('');
      partnerPaths.insertBefore(roster, intro || partnerPaths.firstChild);
    }

    var creatorsCard = document.querySelector('a[href="/pages/patch-partners-media-creators"], a[href="/pages/bbsc-publications?view=patch-partners-media-creators"]');
    if (creatorsCard) {
      creatorsCard.href = '/pages/patch-partners-media-creators';
      creatorsCard.classList.add('pp-category-card--active', 'pp-category-card--has-listing');
      if (!creatorsCard.querySelector('.pp-category-availability')) {
        creatorsCard.insertAdjacentHTML('afterbegin', '<b class="pp-category-availability">✓ Partners Available</b>');
      }
      if (creatorsCard.textContent.indexOf('Big Bud Billy') === -1) {
        var action = creatorsCard.querySelector('span:last-child');
        var listing = document.createElement('div');
        listing.className = 'pp-category-card__listing';
        listing.setAttribute('aria-label', 'Approved partner in Creators And Media');
        listing.innerHTML = '<b>Approved Partner</b><strong>Big Bud Billy / Billy Taylor</strong>';
        creatorsCard.insertBefore(listing, action || null);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensurePatchPartnersBilly);
  } else {
    ensurePatchPartnersBilly();
  }

  function record(action, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'bbsc_action', bbsc_action: action }, details || {}));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;
    var explicitAction = link.getAttribute('data-bbsc-track');
    var href = link.getAttribute('href') || '';
    var action = explicitAction;
    if (!action && /\/pages\/the-legal-leaf/.test(href)) action = 'legal-leaf';
    if (!action && /\/pages\/cannabis-news-watch/.test(href)) action = 'news-watch';
    if (!action && /\/collections\//.test(href)) action = 'shop-support';
    if (action) record(action, { link_url: href, link_text: (link.textContent || '').trim().slice(0, 100) });
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="contact"], form[action*="customer"]')) {
      var action = event.target.id === 'PatchPartnerForm' ? 'patch-partner-inquiry' : 'newsletter-signup';
      record(action);
    }
  });

  var path = window.location.pathname;
  if (path === '/pages/bbsc-membership-signup' || new URLSearchParams(window.location.search).get('view') === 'bbsc-membership-signup') record('membership-page-view');
  if (path === '/pages/patch-partners' || new URLSearchParams(window.location.search).get('view') === 'patch-partners') record('patch-partners-page-view');
  if (path === '/pages/the-legal-leaf') record('legal-leaf-page-view');
})();
